import { useState } from "react";
import { Col, FormControl, FormText, Row } from "react-bootstrap";

import Block from "./Block.jsx";

const PopoverPanelWithBlockFilter = ({ categoryBlocks, close, dragStart, dragStop }) => {
  const [filterText, setFilterText] = useState("");

  const handleFilterTextChange = (e) => setFilterText(e.currentTarget.value);

  const filteredBlocks =
    filterText.length > 0 ? categoryBlocks.filter((block) => block.getLabel().toLowerCase().includes(filterText.toLowerCase())) : categoryBlocks;

  return (
    <>
      <Row className="my-2">
        <Col className="border-bottom border-1">
          <FormControl
            value={filterText}
            onChange={handleFilterTextChange}
            type="search"
            size="sm"
            placeholder="Search blocks..."
          />
          <FormText
            muted
            style={{ visibility: filterText.length > 0 && filteredBlocks.length > 0 ? "visible" : "hidden" }}
          >
            {filteredBlocks.length} block{filteredBlocks.length === 1 ? "" : "s"} found.
          </FormText>
        </Col>
      </Row>
      <Row>
        {filteredBlocks.length > 0 ? (
          <>
            {filteredBlocks.map((block) => (
              <Block
                key={block.getId()}
                block={block}
                close={close}
                dragStart={dragStart}
                dragStop={dragStop}
              />
            ))}
          </>
        ) : (
          <Col>
            <p>No matching blocks found!!!</p>
          </Col>
        )}
      </Row>
    </>
  );
};

export default PopoverPanelWithBlockFilter;
